/**
 * AV API
 * AV for GWR Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { GeometergeschaeftNummerSearchRequestMeta } from './geometergeschaeftNummerSearchRequestMeta';
import { AvMutationsNummerRequestMeta } from './avMutationsNummerRequestMeta';
import { GeometerRechtsgueltigHaengigOptionMeta } from './geometerRechtsgueltigHaengigOptionMeta';


export interface GeometergeschaeftSearchRequestMeta { 
    avMutationsNummer?: AvMutationsNummerRequestMeta;
    mAvMutationsNummer?: FieldMetaData;
    verarbeitungsArt?: GeometergeschaeftSearchRequestMeta.VerarbeitungsArtEnum;
    mVerarbeitungsArt?: FieldMetaData;
    geschaeftsTypList?: Array<GeometergeschaeftSearchRequestMeta.GeschaeftsTypListEnum>;
    mGeschaeftsTypList?: FieldMetaData;
    beschreibung?: string;
    mBeschreibung?: FieldMetaData;
    status?: GeometerRechtsgueltigHaengigOptionMeta;
    mStatus?: FieldMetaData;
    geometerGeschaeft?: GeometergeschaeftNummerSearchRequestMeta;
    mGeometerGeschaeft?: FieldMetaData;
    geschaeftsTyp?: GeometergeschaeftSearchRequestMeta.GeschaeftsTypEnum;
    mGeschaeftsTyp?: FieldMetaData;
}
export namespace GeometergeschaeftSearchRequestMeta {
    export type VerarbeitungsArtEnum = 'STANDARD' | 'LANDUMLEGUNG' | 'FLAECHENBERICHTIGUNG' | 'ERSTERHEBUNG_ERNEUERUNG' | 'AV_BEMERKUNG';
    export const VerarbeitungsArtEnum = {
        STANDARD: 'STANDARD' as VerarbeitungsArtEnum,
        LANDUMLEGUNG: 'LANDUMLEGUNG' as VerarbeitungsArtEnum,
        FLAECHENBERICHTIGUNG: 'FLAECHENBERICHTIGUNG' as VerarbeitungsArtEnum,
        ERSTERHEBUNGERNEUERUNG: 'ERSTERHEBUNG_ERNEUERUNG' as VerarbeitungsArtEnum,
        AVBEMERKUNG: 'AV_BEMERKUNG' as VerarbeitungsArtEnum
    };
    export type GeschaeftsTypListEnum = 'DEFAULT_OHNE_GRUNDBUCH' | 'DEFAULT_MIT_GRUNDBUCH';
    export const GeschaeftsTypListEnum = {
        OHNEGRUNDBUCH: 'DEFAULT_OHNE_GRUNDBUCH' as GeschaeftsTypListEnum,
        MITGRUNDBUCH: 'DEFAULT_MIT_GRUNDBUCH' as GeschaeftsTypListEnum
    };
    export type GeschaeftsTypEnum = 'DEFAULT_OHNE_GRUNDBUCH' | 'DEFAULT_MIT_GRUNDBUCH';
    export const GeschaeftsTypEnum = {
        OHNEGRUNDBUCH: 'DEFAULT_OHNE_GRUNDBUCH' as GeschaeftsTypEnum,
        MITGRUNDBUCH: 'DEFAULT_MIT_GRUNDBUCH' as GeschaeftsTypEnum
    };
}


